import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { IdentityBrandingService } from 'src/app/services/identityBranding.service';
import { LoggingService } from 'src/app/services/logging.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  templateUrl: './branding-tab-colours.component.html'
})
export class BrandingTabColoursComponent implements OnInit {

  brandingElements!: { Name: string; }[];
  allowReset: boolean = true;

  invalidInput: boolean = false;
  showAdvancedColours: boolean = false;
  
  // Basic colours
  fontLightColour!: string;
  fontDarkColour!: string;
  headerColour!: string;
  headerFontColour!: string;
  headerFontColourType!: string;
  identityBackgroundColour!: string;
  identityFontColour!: string;
  identityFontColourType!: string;
  primaryColour!: string;
  primaryHoverColour!: string;
  primaryDisabledColour!: string;
  primaryFontColour!: string;
  primaryFontColourType!: string;
  secondaryColour!: string;
  secondaryHoverColour!: string;
  secondaryDisabledColour!: string;
  secondaryFontColour!: string;
  secondaryFontColourType!: string;
  platformBackgroundColour!: string;
  emailButtonColour!: string;
  emailButtonFontColour!: string;
  emailButtonFontColourType!: string;

  // Advanced colours
  successColour!: string;
  successHoverColour!: string;
  successDisabledColour!: string;
  successFontColour!: string;
  successFontColourType!: string;
  warningColour!: string;
  warningHoverColour!: string;
  warningDisabledColour!: string;
  warningFontColour!: string;
  warningFontColourType!: string;
  dangerColour!: string;
  dangerHoverColour!: string;
  dangerDisabledColour!: string;
  dangerFontColour!: string;
  dangerFontColourType!: string;
  infoColour!: string;
  infoHoverColour!: string;
  infoDisabledColour!: string;
  infoFontColour!: string;
  infoFontColourType!: string;

  translations = <any>{};
  
  constructor(protected brandingService: IdentityBrandingService, protected loggingService: LoggingService, protected toastService: ToastService, protected translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.getTranslations();
    this.translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.Saved',
      'Toasts.ChangesSaved'
    ]).subscribe(translation => {
      this.translations.toastSaved = translation['Toasts.Saved'];
      this.translations.toastChangedSaved = translation['Toasts.ChangesSaved'];
    });
  }

  hexToRgb(hex: string | undefined | null) {
    if(hex === undefined || hex === null) return null;
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let rgb = parseInt(result![1], 16) + "," +  parseInt(result![2], 16) + "," +parseInt(result![3], 16);
    return rgb;
  }

  resetColour(colour: string){
    //empty function
  }

  updateColours(){
    //empty function
  }

}

@Component({
  selector: 'app-branding-tab-colours-organisation',
  templateUrl: './branding-tab-colours.component.html'
})
export class BrandingTabColoursOrganisationComponent extends BrandingTabColoursComponent {

  private _organisation!: any;
  get organisation(): any {
    return this._organisation;
  }
  @Input('organisation') set organisation(val: any){
    this._organisation = val;
    if(this._organisation){
      this.getColours().catch((error) => this.loggingService.logException(error));
    }
  }

  constructor(protected override brandingService: IdentityBrandingService, protected override loggingService: LoggingService, protected override toastService: ToastService, protected override translateService: TranslateService) {
    super(brandingService, loggingService, toastService, translateService);
  }
  
private async getColours() {
    (await this.brandingService.getColoursOrganisation(this.organisation.guid)).subscribe({
      next: (data: any) => {
        // Basic colours
        this.fontLightColour = data.fontLightColour;
        this.fontDarkColour = data.fontDarkColour;
        this.headerColour = data.headerColour;
        this.headerFontColour = data.headerFontColour;
        this.headerFontColourType = data.headerFontColourType;
        this.identityBackgroundColour = data.identityBackgroundColour;
        this.identityFontColour = data.identityFontColour;
        this.identityFontColourType = data.identityFontColourType;
        this.primaryColour = data.primaryColour;
        this.primaryDisabledColour = data.primaryDisabledColour;
        this.primaryHoverColour = data.primaryHoverColour;
        this.primaryFontColour = data.primaryFontColour;
        this.primaryFontColourType = data.primaryFontColourType;
        this.secondaryColour = data.secondaryColour;
        this.secondaryDisabledColour = data.secondaryDisabledColour;
        this.secondaryHoverColour = data.secondaryHoverColour;
        this.secondaryFontColour = data.secondaryFontColour;
        this.secondaryFontColourType = data.secondaryFontColourType;
        this.platformBackgroundColour = data.platformBackgroundColour;
        this.emailButtonColour = data.emailButtonColour;
        this.emailButtonFontColour = data.emailButtonFontColour;
        this.emailButtonFontColourType = data.emailButtonFontColourType;
      
        // Advanced colours
        this.successColour = data.successColour;
        this.successHoverColour = data.successHoverColour;
        this.successDisabledColour = data.successDisabledColour;
        this.successFontColour = data.successFontColour;
        this.successFontColourType = data.successFontColourType;
        this.warningColour = data.warningColour;
        this.warningHoverColour = data.warningHoverColour;
        this.warningDisabledColour = data.warningDisabledColour;
        this.warningFontColour = data.warningFontColour;
        this.warningFontColourType = data.warningFontColourType;
        this.dangerColour = data.dangerColour;
        this.dangerHoverColour = data.dangerHoverColour;
        this.dangerDisabledColour = data.dangerDisabledColour;
        this.dangerFontColour = data.dangerFontColour;
        this.dangerFontColourType = data.dangerFontColourType;
        this.infoColour = data.infoColour;
        this.infoHoverColour = data.infoHoverColour;
        this.infoDisabledColour = data.infoDisabledColour;
        this.infoFontColour = data.infoFontColour;
        this.infoFontColourType = data.infoFontColourType;
      }
    })
  }

  override updateColours(){
    this.headerFontColour = this.headerFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.identityFontColour = this.identityFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.primaryFontColour = this.primaryFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.emailButtonFontColour = this.emailButtonFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.secondaryFontColour = this.secondaryFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.successFontColour = this.successFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.warningFontColour = this.warningFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.dangerFontColour = this.dangerFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.infoFontColour = this.infoFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.brandingService.postColoursOrganisation(this.organisation.guid, {
      "fontLightColour": this.fontLightColour,
      "fontDarkColour": this.fontDarkColour,
      "headerColour": this.headerColour,
      "headerFontColour": this.headerFontColour,
      "headerFontColourType": this.headerFontColourType,
      "identityBackgroundColour": this.identityBackgroundColour,
      "identityFontColour": this.identityFontColour,
      "identityFontColourType": this.identityFontColourType,
      "primaryColour": this.primaryColour,
      "primaryHoverColour": this.primaryHoverColour,
      "primaryDisabledColour": this.primaryDisabledColour,
      "primaryFontColour": this.primaryFontColour,
      "primaryFontColourType": this.primaryFontColourType,
      "secondaryColour": this.secondaryColour,
      "secondaryHoverColour": this.secondaryHoverColour,
      "secondaryDisabledColour": this.secondaryDisabledColour,
      "secondaryFontColour": this.secondaryFontColour,
      "secondaryFontColourType": this.secondaryFontColourType,
      "platformBackgroundColour": this.platformBackgroundColour,
      "emailButtonColour": this.emailButtonColour,
      "emailButtonFontColour": this.emailButtonFontColour,
      "emailButtonFontColourType": this.emailButtonFontColourType,
      "successColour": this.successColour,
      "successHoverColour": this.successHoverColour,
      "successDisabledColour": this.successDisabledColour,
      "successFontColour": this.successFontColour,
      "successFontColourType": this.successFontColourType,
      "warningColour": this.warningColour,
      "warningHoverColour": this.warningHoverColour,
      "warningDisabledColour": this.warningDisabledColour,
      "warningFontColour": this.warningFontColour,
      "warningFontColourType": this.warningFontColourType,
      "dangerColour": this.dangerColour,
      "dangerHoverColour": this.dangerHoverColour,
      "dangerDisabledColour": this.dangerDisabledColour,
      "dangerFontColour": this.dangerFontColour,
      "dangerFontColourType": this.dangerFontColourType,
      "infoColour": this.infoColour,
      "infoHoverColour": this.infoHoverColour,
      "infoDisabledColour": this.infoDisabledColour,
      "infoFontColour": this.infoFontColour,
      "infoFontColourType": this.infoFontColourType
    })
    .then(value => {
      lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      }).catch((error) => this.loggingService.logException(error));
    })
    .catch((error) => this.loggingService.logException(error));
  }

  override resetColour(colour: string) {
    this.brandingService.deleteColourOrganisation(this.organisation.guid, colour).then(value =>
      lastValueFrom(value)
        .then(() => {
          this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
          this.getColours();
        })
        .catch((error) => this.loggingService.logException(error))
    ).catch((error:any) => this.loggingService.logException(error));
  }

  
}

@Component({
  selector: 'app-branding-tab-colours-whitelabel',
  templateUrl: './branding-tab-colours.component.html'
})
export class BrandingTabColoursWhiteLabelComponent extends BrandingTabColoursComponent {
  private _whiteLabel!: any;
  get whiteLabel(): any {
    return this._whiteLabel;
  }
  @Input('whiteLabel') set whiteLabel(val: any){
    this._whiteLabel = val;
    if(this._whiteLabel){
      this.getColours().catch((error) => this.loggingService.logException(error));
    }
  }

  constructor(protected override brandingService: IdentityBrandingService, protected override loggingService: LoggingService, protected override toastService: ToastService, protected override translateService: TranslateService) {
    super(brandingService, loggingService, toastService, translateService);
  }

  private async getColours() {
    (await this.brandingService.getColoursWhiteLabel(this.whiteLabel.guid)).subscribe({
      next: (data: any) => {
        // Basic colours
        this.fontLightColour = data.fontLightColour;
        this.fontDarkColour = data.fontDarkColour;
        this.headerColour = data.headerColour;
        this.headerFontColour = data.headerFontColour;
        this.headerFontColourType = data.headerFontColourType;
        this.identityBackgroundColour = data.identityBackgroundColour;
        this.identityFontColour = data.identityFontColour;
        this.identityFontColourType = data.identityFontColourType;
        this.primaryColour = data.primaryColour;
        this.primaryDisabledColour = data.primaryDisabledColour;
        this.primaryHoverColour = data.primaryHoverColour;
        this.primaryFontColour = data.primaryFontColour;
        this.primaryFontColourType = data.primaryFontColourType;
        this.secondaryColour = data.secondaryColour;
        this.secondaryDisabledColour = data.secondaryDisabledColour;
        this.secondaryHoverColour = data.secondaryHoverColour;
        this.secondaryFontColour = data.secondaryFontColour;
        this.secondaryFontColourType = data.secondaryFontColourType;
        this.platformBackgroundColour = data.platformBackgroundColour;
        this.emailButtonColour = data.emailButtonColour;
        this.emailButtonFontColour = data.emailButtonFontColour;
        this.emailButtonFontColourType = data.emailButtonFontColourType;
      
        // Advanced colours
        this.successColour = data.successColour;
        this.successHoverColour = data.successHoverColour;
        this.successDisabledColour = data.successDisabledColour;
        this.successFontColour = data.successFontColour;
        this.successFontColourType = data.successFontColourType;
        this.warningColour = data.warningColour;
        this.warningHoverColour = data.warningHoverColour;
        this.warningDisabledColour = data.warningDisabledColour;
        this.warningFontColour = data.warningFontColour;
        this.warningFontColourType = data.warningFontColourType;
        this.dangerColour = data.dangerColour;
        this.dangerHoverColour = data.dangerHoverColour;
        this.dangerDisabledColour = data.dangerDisabledColour;
        this.dangerFontColour = data.dangerFontColour;
        this.dangerFontColourType = data.dangerFontColourType;
        this.infoColour = data.infoColour;
        this.infoHoverColour = data.infoHoverColour;
        this.infoDisabledColour = data.infoDisabledColour;
        this.infoFontColour = data.infoFontColour;
        this.infoFontColourType = data.infoFontColourType;
      }
    });
  }

  override updateColours(){
    this.headerFontColour = this.headerFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.identityFontColour = this.identityFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.primaryFontColour = this.primaryFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.emailButtonFontColour = this.emailButtonFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.secondaryFontColour = this.secondaryFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.successFontColour = this.successFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.warningFontColour = this.warningFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.dangerFontColour = this.dangerFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.infoFontColour = this.infoFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.brandingService.postColoursWhiteLabel(this.whiteLabel.guid, {
      "fontLightColour": this.fontLightColour,
      "fontDarkColour": this.fontDarkColour,
      "headerColour": this.headerColour,
      "headerFontColour": this.headerFontColour,
      "headerFontColourType": this.headerFontColourType,
      "identityBackgroundColour": this.identityBackgroundColour,
      "identityFontColour": this.identityFontColour,
      "identityFontColourType": this.identityFontColourType,
      "primaryColour": this.primaryColour,
      "primaryHoverColour": this.primaryHoverColour,
      "primaryDisabledColour": this.primaryDisabledColour,
      "primaryFontColour": this.primaryFontColour,
      "primaryFontColourType": this.primaryFontColourType,
      "secondaryColour": this.secondaryColour,
      "secondaryHoverColour": this.secondaryHoverColour,
      "secondaryDisabledColour": this.secondaryDisabledColour,
      "secondaryFontColour": this.secondaryFontColour,
      "secondaryFontColourType": this.secondaryFontColourType,
      "platformBackgroundColour": this.platformBackgroundColour,
      "emailButtonColour": this.emailButtonColour,
      "emailButtonFontColour": this.emailButtonFontColour,
      "emailButtonFontColourType": this.emailButtonFontColourType,
      "successColour": this.successColour,
      "successHoverColour": this.successHoverColour,
      "successDisabledColour": this.successDisabledColour,
      "successFontColour": this.successFontColour,
      "successFontColourType": this.successFontColourType,
      "warningColour": this.warningColour,
      "warningHoverColour": this.warningHoverColour,
      "warningDisabledColour": this.warningDisabledColour,
      "warningFontColour": this.warningFontColour,
      "warningFontColourType": this.warningFontColourType,
      "dangerColour": this.dangerColour,
      "dangerHoverColour": this.dangerHoverColour,
      "dangerDisabledColour": this.dangerDisabledColour,
      "dangerFontColour": this.dangerFontColour,
      "dangerFontColourType": this.dangerFontColourType,
      "infoColour": this.infoColour,
      "infoHoverColour": this.infoHoverColour,
      "infoDisabledColour": this.infoDisabledColour,
      "infoFontColour": this.infoFontColour,
      "infoFontColourType": this.infoFontColourType
    })
    .then(value => {
      lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      }).catch((error) => this.loggingService.logException(error));
    })
    .catch((error) => this.loggingService.logException(error));
  }

  override resetColour(colour: string) {
    this.brandingService.deleteColourWhiteLabel(this.whiteLabel.guid, colour).then(value =>
      lastValueFrom(value)
        .then(() => {
          this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
          this.getColours();
        })
        .catch((error) => this.loggingService.logException(error))
    ).catch((error:any) => this.loggingService.logException(error));
  }
}

@Component({
  selector: 'app-branding-tab-colours-system',
  templateUrl: './branding-tab-colours.component.html'
})
export class BrandingTabColoursSystemComponent extends BrandingTabColoursComponent {
  private _system!: any;
  get system(): any {
    return this._system;
  }
  @Input('system') set system(val: any){
    this._system = val;
    if(this._system){
      this.getColours().catch((error) => this.loggingService.logException(error));
    }
  }

  override allowReset: boolean = false;

  constructor(protected override brandingService: IdentityBrandingService, protected override loggingService: LoggingService, protected override toastService: ToastService, protected override translateService: TranslateService) {
    super(brandingService, loggingService, toastService, translateService);
  }

  private async getColours() {
    (await this.brandingService.getColoursSystem(this.system.guid)).subscribe({
      next: (data: any) => {
        // Basic colours
        this.fontLightColour = data.fontLightColour;
        this.fontDarkColour = data.fontDarkColour;
        this.headerColour = data.headerColour;
        this.headerFontColour = data.headerFontColour;
        this.headerFontColourType = data.headerFontColourType;
        this.identityBackgroundColour = data.identityBackgroundColour;
        this.identityFontColour = data.identityFontColour;
        this.identityFontColourType = data.identityFontColourType;
        this.primaryColour = data.primaryColour;
        this.primaryDisabledColour = data.primaryDisabledColour;
        this.primaryHoverColour = data.primaryHoverColour;
        this.primaryFontColour = data.primaryFontColour;
        this.primaryFontColourType = data.primaryFontColourType;
        this.secondaryColour = data.secondaryColour;
        this.secondaryDisabledColour = data.secondaryDisabledColour;
        this.secondaryHoverColour = data.secondaryHoverColour;
        this.secondaryFontColour = data.secondaryFontColour;
        this.secondaryFontColourType = data.secondaryFontColourType;
        this.platformBackgroundColour = data.platformBackgroundColour;
        this.emailButtonColour = data.emailButtonColour;
        this.emailButtonFontColour = data.emailButtonFontColour;
        this.emailButtonFontColourType = data.emailButtonFontColourType;
      
        // Advanced colours
        this.successColour = data.successColour;
        this.successHoverColour = data.successHoverColour;
        this.successDisabledColour = data.successDisabledColour;
        this.successFontColour = data.successFontColour;
        this.successFontColourType = data.successFontColourType;
        this.warningColour = data.warningColour;
        this.warningHoverColour = data.warningHoverColour;
        this.warningDisabledColour = data.warningDisabledColour;
        this.warningFontColour = data.warningFontColour;
        this.warningFontColourType = data.warningFontColourType;
        this.dangerColour = data.dangerColour;
        this.dangerHoverColour = data.dangerHoverColour;
        this.dangerDisabledColour = data.dangerDisabledColour;
        this.dangerFontColour = data.dangerFontColour;
        this.dangerFontColourType = data.dangerFontColourType;
        this.infoColour = data.infoColour;
        this.infoHoverColour = data.infoHoverColour;
        this.infoDisabledColour = data.infoDisabledColour;
        this.infoFontColour = data.infoFontColour;
        this.infoFontColourType = data.infoFontColourType;
      }
    });
  }

  override updateColours(){
    this.headerFontColour = this.headerFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.identityFontColour = this.identityFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.primaryFontColour = this.primaryFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.emailButtonFontColour = this.emailButtonFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.secondaryFontColour = this.secondaryFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.successFontColour = this.successFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.warningFontColour = this.warningFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.dangerFontColour = this.dangerFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.infoFontColour = this.infoFontColourType === 'light' ? this.fontLightColour : this.fontDarkColour;
    this.brandingService.postColoursSystem(this.system.guid, {
      "fontLightColour": this.fontLightColour,
      "fontDarkColour": this.fontDarkColour,
      "headerColour": this.headerColour,
      "headerFontColour": this.headerFontColour,
      "headerFontColourType": this.headerFontColourType,
      "identityBackgroundColour": this.identityBackgroundColour,
      "identityFontColour": this.identityFontColour,
      "identityFontColourType": this.identityFontColourType,
      "primaryColour": this.primaryColour,
      "primaryHoverColour": this.primaryHoverColour,
      "primaryDisabledColour": this.primaryDisabledColour,
      "primaryFontColour": this.primaryFontColour,
      "primaryFontColourType": this.primaryFontColourType,
      "secondaryColour": this.secondaryColour,
      "secondaryHoverColour": this.secondaryHoverColour,
      "secondaryDisabledColour": this.secondaryDisabledColour,
      "secondaryFontColour": this.secondaryFontColour,
      "secondaryFontColourType": this.secondaryFontColourType,
      "platformBackgroundColour": this.platformBackgroundColour,
      "emailButtonColour": this.emailButtonColour,
      "emailButtonFontColour": this.emailButtonFontColour,
      "emailButtonFontColourType": this.emailButtonFontColourType,
      "successColour": this.successColour,
      "successHoverColour": this.successHoverColour,
      "successDisabledColour": this.successDisabledColour,
      "successFontColour": this.successFontColour,
      "successFontColourType": this.successFontColourType,
      "warningColour": this.warningColour,
      "warningHoverColour": this.warningHoverColour,
      "warningDisabledColour": this.warningDisabledColour,
      "warningFontColour": this.warningFontColour,
      "warningFontColourType": this.warningFontColourType,
      "dangerColour": this.dangerColour,
      "dangerHoverColour": this.dangerHoverColour,
      "dangerDisabledColour": this.dangerDisabledColour,
      "dangerFontColour": this.dangerFontColour,
      "dangerFontColourType": this.dangerFontColourType,
      "infoColour": this.infoColour,
      "infoHoverColour": this.infoHoverColour,
      "infoDisabledColour": this.infoDisabledColour,
      "infoFontColour": this.infoFontColour,
      "infoFontColourType": this.infoFontColourType
    })
    .then(value => {
      lastValueFrom(value).then(() => {
        this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
      }).catch((error) => this.loggingService.logException(error));
    })
    .catch((error) => this.loggingService.logException(error));
  }

  override resetColour(colour: string) {
    this.brandingService.deleteColourSystem(this.system.guid, colour).then(value =>
      lastValueFrom(value)
        .then(() => {
          this.toastService.showSuccess(this.translations.toastSaved, this.translations.toastChangedSaved);
          this.getColours();
        })
        .catch((error) => this.loggingService.logException(error))
    ).catch((error:any) => this.loggingService.logException(error));
  }
}
